import { DictionaryDto } from "gql/graphql";

export function CustomOption({ option }: { option: DictionaryDto }) {
  const { style, value } = option;
  const optionStyles: Record<string, string> = {};

  style.backgroundColor &&
    (optionStyles["backgroundColor"] = style.backgroundColor);
  style.textColor && (optionStyles["color"] = style.textColor);

  return (
    <span
      className="block py-[5px] px-[12px] hover:brightness-90"
      style={optionStyles}
    >
      {value.value}
    </span>
  );
}
